// src/i18n/es/groups.js
const groups = {
    name: 'Grupo |||| Grupos',
    fields: {
        name: 'Nombre',
        description: 'Descripción',
        hotels: 'Hoteles',
        users: 'Usuarios',
        status: 'Estado',
        createdAt: 'Fecha de Creación',
    },
    actions: {
        create: 'Crear Grupo',
        manage_hotels: 'Gestionar Hoteles',
        view_stats: 'Ver Estadísticas',
        export: 'Exportar Datos',
        activate: 'Activar',
        deactivate: 'Desactivar',
        archive: 'Archivar',
    },
    titles: {
        create: 'Crear Grupo',
        edit: 'Editar Grupo',
    },
    sections: {
        basic_info: 'Información Básica',
        basic_info_subtitle: 'Datos básicos y configuración del grupo',
        new_group_title: 'Nuevo Grupo',
        new_group_subtitle: 'Complete los datos para crear un nuevo grupo',
    },
    help: {
        name: 'Nombre único que identifica al grupo',
        description: 'Descripción opcional del grupo (máx. 500 caracteres)',
    },
    list: {
        title: 'Grupos',
        search: 'Buscar',
        search_placeholder: 'Nombre o descripción...',
    },
    empty: 'No hay grupos',
    empty_help: 'Crea tu primer grupo para comenzar',
    access_denied: 'Solo los SuperAdmins pueden gestionar grupos.',
    dialogs: {
        delete_title: 'Eliminar Grupo',
        delete_message: '¿Estás seguro de que quieres eliminar el grupo "{{name}}"?',
        delete_generic: '¿Estás seguro de que quieres eliminar este grupo?',
        delete_warning: 'Esta acción no se puede deshacer.',
        delete_warning_with_hotels: 'El grupo "{{name}}" tiene {{count}} hotel(es) asociado(s). ¿Estás seguro de que quieres eliminarlo?',
        delete_cascade_warning: 'Esta acción afectará a los hoteles asociados.',
        item_to_delete: 'Elemento a eliminar:',
    },
    notifications: {
        activated: 'Grupo activado correctamente',
        deactivated: 'Grupo desactivado correctamente',
        created: 'Grupo creado con éxito',
        updated: 'Grupo actualizado con éxito',
        deleted: 'Grupo eliminado correctamente',
    },
    errors: {
        create: 'Error al crear el grupo',
        update: 'Error al actualizar el grupo',
        delete: 'Error al eliminar el grupo',
        load: 'Error al cargar los grupos',
    },
};

export default groups;
